import { classNameColorTypes, colorType } from "../interfaces";
/**
 * Адаптер для цвета кнопок
 */
class ColorButtonAdapter {
    /**
     * @param color
     */
    adapt({ color }: {[key: string]: any, color: colorType}): classNameColorTypes {
        switch (color) {
            case 'red': return 'p-button-danger';
            case 'green': return 'p-button-success';
            case 'yellow': return 'p-button-warning';
            default: return 'p-button-primary'
        }
    }
}

export default ColorButtonAdapter;